export const MAP_ZOOM_DEFAULT = 10
